import Dashboard from './Dashboard';
import Ownership from './Ownership';
import Leasing from './LeasingComponents/Leasing';
import Mapping from './Mapping';
import Documents from './Documents';
// import Reports from './Reports';
import Reports from './ReportComponents/Reports.redesign';
import Staffing from './StaffingPage';
import Settings from './Settings';
import TractDetail from './TractComponents/TractDetail';
import ReportDetail from './ReportComponents/ReportDetail';
import RunsheetPage from './RunsheetPage';
import RunsheetDetails from './RunsheetDetails';
import ThirdPartyLeases from './ThirdPartyLeases/ThirdPartyLeasesPage';

export default {
    Dashboard,
    Ownership,
    TractDetail,
    Leasing,
    Mapping,
    Documents,
    Reports,
    ReportDetail,
    Staffing,
    Settings,
    RunsheetPage,
    RunsheetDetail: RunsheetDetails,
    ThirdPartyLeases
};



// WEBPACK FOOTER //
// ./src/components/project/sections/index.ts